<template>
    <div>
      <Head title="BacktoWorkConnect.ie - Forgot Password" />
        <v-card elevation="24" style="margin:20px auto;max-width:800px">
            <v-card-title>Forgot Password</v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row v-if="success && !errors.email">
                        <v-alert type="success">
                            If this email is in our database then a password reset link was sent to it.
                        </v-alert>
                    </v-row>
                    <v-row v-if="errors && errors.email">
                        <v-col cols="12" lg="12">
                            <v-alert type="error">
                                {{ errors.email }}
                            </v-alert>
                        </v-col>
                    </v-row>
                    <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation>
                        <v-row>
                        <v-col cols="12" lg="12">
                            <p>Please enter the email for the account whose password you would like to reset.</p>
                            <v-text-field validate-on-blur :rules="emailRules" v-model="form.email" label="Email" type="email" required="true"></v-text-field>
                            <v-btn :disabled="!valid" @click="submitForgot()"><v-icon>mdi-send</v-icon> Submit</v-btn>
                        </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>   
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue' 
  import Layout from '@/Shared/VuetifyLayout'
  
  export default {
    props: {
      baseurl: String,
      errors: Object,
      status: String,
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            success:false,
            form: this.$inertia.form({
                email: '',
            }),
            valid:false,
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
        }
    },
    methods: {
      submitForgot() {
        this.form.post('', {
            onSuccess: (res) => {
                this.success=true;
                console.log('success!',res)
                
            },
            onError: (res) => {
                this.success=true;
                console.log('error',res)
            },
        })
      }
    }
  }
  </script>
  